import React from "react";
import { ServiceTasks } from "@opstel/serviceTasks/ServiceTasks";
import { ErrorState } from "@shared/common/components/State/ErrorState";
import { LoadingState } from "@shared/common/components/State/LoadingState";
import { useServiceTasksQuery } from "@opstel/query/v2/useServiceTasksQuery";
import { useKnopIsLoading } from "@shared/common/hooks/useKnopIsLoading";
import { EmptyState } from "@shared/common/components/State/EmptyState";

export function ServiceTasksWrapper(): React.JSX.Element {
  const isKnopLoading = useKnopIsLoading((state) => state.isLoading);
  const { data, isLoading, isError } = useServiceTasksQuery();

  if (isKnopLoading || isLoading) return <LoadingState fullPage={false} />;
  if (isError) return <ErrorState />;
  if (!data) return <EmptyState />;

  return <ServiceTasks data={data} />;
}
